import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, DialogActions, DialogContent } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Map from '../../components/google/maps/Map';
import { FullScreenDialog } from '../../components/FullScreenDialog';
import { DialogTitle } from '../../components/DialogTitle';
import { IrrigationEditControls } from './IrrigationEditControls';
import * as irrigationService from '../../services/irrigation-service';
import { useAlerts } from '../../hooks/use-alerts';
import { useLayers } from './use-layers';
import { useContext } from './context';
import { useMapProperties } from '../../components/google/maps/use-map-properties';

IrrigationEditorDialog.propTypes = {
  boundary: PropTypes.shape({ id: PropTypes.number }),
  growerId: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
};

export function IrrigationEditorDialog(props) {
  const { growerId, close } = props;
  const [boundary, setBoundary] = useState(props.boundary);
  const [isWorking, setIsWorking] = useState(false);
  const { showError } = useAlerts();
  const layers = useLayers();
  const { map } = useContext();
  const mapProperties = useMapProperties(map);

  return (
    <FullScreenDialog>
      <DialogTitle
        title={`${boundary.id ? 'Edit' : 'Add'} Irrigation Boundary`}
        onClose={() => close()}
      />
      <DialogContent sx={{ p: 0 }}>{buildMap()}</DialogContent>
      <DialogActions>
        <Button
          disabled={isWorking}
          variant="contained"
          color="dark"
          onClick={() => close()}
        >
          Cancel
        </Button>
        <LoadingButton
          disabled={!boundary?.shape}
          variant="contained"
          onClick={onSaveClick}
          loading={isWorking}
        >
          Save
        </LoadingButton>
      </DialogActions>
    </FullScreenDialog>
  );

  function onSaveClick() {
    setIsWorking(true);
    irrigationService
      .save(growerId, boundary)
      .then((response) => close(response, boundary))
      .catch(showError)
      .finally(() => setIsWorking(false));
  }

  function buildMap() {
    if (!mapProperties?.extent) return null;

    return (
      <Map
        center={mapProperties.center}
        zoom={mapProperties.zoom}
        layers={layers}
        filters={{ growerId }}
      >
        <IrrigationEditControls boundary={boundary} setBoundary={setBoundary} />
      </Map>
    );
  }
}
